// Currency formatter
export const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return '$0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

// Date formatter - parses date-only strings (YYYY-MM-DD) as local date to avoid timezone off-by-one
function toLocalDate(date) {
  if (!date) return null;
  if (date instanceof Date) return date;
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date.trim())) {
    const [y, m, d] = date.trim().split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  return new Date(date);
}

export const formatDate = (date) => {
  const d = toLocalDate(date);
  if (!d || !Number.isFinite(d.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }).format(d);
};

// Number formatter
export const formatNumber = (number, decimals = 0) => {
  if (number === undefined || number === null) return '0';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(number);
}; 